/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_Loading_CardsInputs */



/**
* | output |
* | --- |
* | "Loading cards…" |
*
* @param {Palette_Loading_CardsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const palette_loading_cards = /** @type {((inputs?: Palette_Loading_CardsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Loading_CardsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Karten werden geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des cartes…")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("正在加载卡牌…")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("正在載入卡牌…")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드를 불러오는 중…")
	return /** @type {LocalizedString} */ ("Loading cards…")
});